<template>
    <div class="wxList wxNoscroll">
        <wxBack></wxBack>
        <div class="bgShow" style="height: 100%;min-height:100vh;">
            <ul v-show="!isHave"style="height: 80%;overflow: scroll;padding-bottom: 17vw;">
                <li v-for="(item,index) in listArr" :key="index">
                    <h4>{{item.title}}</h4>
                    <Button @click="send(item.username,item.id,item.receive_time)" type="primary">查看详情</Button>
                </li>
            </ul>
            <div v-show="isHave" style="height: 100vh;padding: 30px 0;">暂无活动</div>
            <!--{{showIt}}-->
            <!-- <Row>
                <Col span="24" style="height: 100%;">
                    <swiper style="height: 90%;" :options="swiperOption" ref="mySwiper">
                        <swiper-slide class="swiperCon" v-for="(item,index) in listArr" :key="index">
                            <h4>{{item.title}}</h4>
                            <div class="conImg">
                                {{listArr[index]}}
                            </div>
                            <div class="content">
                                {{item.content}}
                            </div>
                            <Button :type="btnType" class="btnClass"  @click="send(item.username,item.id)">{{btnVale}}</Button>
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-pagination"><span v-for="item in listArr" :key="item.title"></span></div>
                </Col>
            </Row> -->
            <wxNav></wxNav>
        </div>
    </div>
</template>


<script>
    import { mapState, mapGetters, mapMutations } from "vuex";
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    import wxBack from "../wxBack"
    import wxNav from "../wxNav"
    export default {
        props:["wxCode"],
        data () {
          return{
          		isHave:false,
                btnType: "success",
                btnVale:"确认报名",
                userName:"",
                showIt: {},
                listArr : [],
                imgStr: [],
                imgLen: 0,
                swiperOption: {
                  observer:true,
                  slidesPerView : 1.3,
                  spaceBetween : "8%",
                  centeredSlides : true,
				  observeParents:true,
                  debugger: true,
                  pagination: {
                    el: '.swiper-pagination',
                    clickable :true
                    }
                },
            }
        },
        components:{
            wxNav,
            swiper,
            swiperSlide,
            wxBack
        },
        computed: {
		    ...mapState(["xcxId","xcxUser","xcxReal"]),
		},
        methods:{
            ...mapMutations(["SET_XCXID","SET_XCXUSER","SET_XCXREAL","SET_LOADING"]),
            send(name,id) {
                this.$router.push("/data/wxSign/"+name+"/"+id);
            },
            isJoin(time,join){
                var is_old = this.isOld(time);
                if(!is_old && join){
                    return false;
                }else if(!is_old && !join){
                    return true;
                }
            },
            isOld(time){
                var curr = new Date();
                curr = curr.format("yyyy-MM-dd hh:mm:ss");
                if(time>curr){
                    return false
                }else{
                    return true;
                }
            },
            // getPeople(){
            //     let params = {};
            //     var that = this;
            //     params.data = {
            //         searchValue: {
            //             "xcx_openId": this.wxCode
            //         }
            //     };
            //     params.url = "/sys/userinfo/list";
            //     params.token = "swgykj9527";
            //     params.success = function(res) {
            //        that.userName = res.data.result.result[0].username;
            //        that.getList();
            //     };
            //     this.ajaxPostWX(params);
            // },
            getList(){
                let params = {};
                var that = this;
                params.data = {
                    searchValue: {
                        "username": this.xcxUser,
                    },
                    order: { _id: -1 },
                };
                params.url = "/sys/receiveuser/list";
                params.token = "swgykj9527";
                params.success = function(res) {
                	that.showIt = res;
                   that.listArr = res.data.result.result;
                   if(!that.listArr.length){
                   		that.isHave = true;
                   }else{
                   	    that.isHave = false;
                   }

                };
                this.ajaxPostWX(params);
            }
        },
        mounted: function() {
            this.SET_LOADING("yes");
            this.getList();
        }
    }
</script>

<style lang="scss">
    @import "../../global/css/swiper.scss";
    .wxList{
    	height: 100vh;
        li{
            width: 90%;
            text-align: left;
            margin: 20px auto;
            padding: 20px;
            box-shadow: 2px 2px 5px #333;
            h4{
                line-height: 20px;
                padding-bottom: 5px;
                font-size: 14px;
                height: auto;
            }
        }
        .swiperCon{
	        height: 100%;
	        text-align: center;
	        background: #fff;
	        border-radius: 10px;
	    }
    }
    .wxList{
        background: url("../../assets/wxBg.png") center -150px no-repeat;
        height: 100%;
        .swiper-pagination{
            left: 0;
            right: 0;
        }
        h4{
            font-size: 5vw;
            word-break: break-all;
            color: #333;
            height: 15vw;
            line-height: 15vw;

        }
        .swiper-pagination-bullet{
            margin: 0 1vw;
        }
        .ivu-row{
            height: 100%;
        }
        .btnClass{
            height: 12vw;
            width: 50vw;
            font-size: 4vw;
            position: absolute;
            bottom: 30px;
            left: 50%;
            margin-left: -25vw;
        }
        .bgShow{
            // height: 100%;
            // width: 100%;
            background: #fff;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            height: 100%;
            width: 90%;
            margin: 0 auto;
            .leftName{
                line-height: 40px;
                font-size: 14px;
            }
        }
    }
    .bgShow{
        width: 90%;
        margin: 0 auto;
    }
    .wxList{
        max-width: 768px;
        margin: 0 auto;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/infoMana/wxList.vue